// extracted by mini-css-extract-plugin
module.exports = {"PageTitle":"PageTitle_PageTitle__XB5JB"};